// src/layout/Breadcrumbs.tsx
import React, { useContext } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import RouteConstant from "../../constants/route.constants";
import { LayoutContext } from "./context/layoutcontext";

const routeNameMap: Record<string, string> = {
  "/": "Home",
  [RouteConstant.desiriUsers]: "Desiri Users",
  [RouteConstant.newinvoice]: "Order Details",
  [RouteConstant.newGenerateInvoice]: "Generate Invoice",
  [RouteConstant.canceledOrders]: "Cancelled Orders",
  // add all other routes you want to show in breadcrumb here
};

const getPathLabel = (path: string): string => {
  // Check if exact match exists in map
  if (routeNameMap[path]) {
    return routeNameMap[path];
  }

  // Convert path to readable label
  const lastSegment = path.split("/").pop() || "";
  return lastSegment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { breadcrumbModel, onBreadcrumbClick } = useContext(LayoutContext);

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const items = pathSegments.map((_, index) => {
    const url = "/" + pathSegments.slice(0, index + 1).join("/");
    const label = getPathLabel(url);
    return {
      label,
      path: url,
      command: () => navigate(url),
      template: (item: any) =>
        index === pathSegments.length - 1 ? (
          <span className="p-menuitem-text">{item.label}</span>
        ) : (
          <a className="p-menuitem-text" onClick={() => navigate(url)}>
            {item.label}
          </a>
        ),
    };
  });

  const home = {
    icon: "pi pi-home",
    command: () => (window.location.href = "/"),
  };

  const model = breadcrumbModel && breadcrumbModel.length > 0 
    ? breadcrumbModel.map((item: any, index: number) => ({
        ...item,
        command: () => {
          // Call the breadcrumb click callback if provided
          if (onBreadcrumbClick && index < breadcrumbModel.length - 1) {
            onBreadcrumbClick(item.label);
          }
        },
        template: (item: any) =>
          index === breadcrumbModel.length - 1 ? (
            <span className="p-menuitem-text">{item.label}</span>
          ) : (
            <a 
              className="p-menuitem-text" 
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (onBreadcrumbClick) {
                  onBreadcrumbClick(item.label);
                }
              }}
            >
              {item.label}
            </a>
          ),
      }))
    : items;
  
  if (!model || !model.length) return null;

  return (
    <div className="mt-8" style={{ padding: "0.75rem 1.5rem 0.5rem" }}>
      <BreadCrumb model={model} home={home} />
    </div>
  );
};

export default Breadcrumbs;
